import comp from "./ToddleDocNameModal";
export default comp;
